import { render, staticRenderFns } from "./ReportSalesSumsPerCustomerPage.vue?vue&type=template&id=f702c28c&scoped=true"
import script from "./ReportSalesSumsPerCustomerPage.vue?vue&type=script&lang=js"
export * from "./ReportSalesSumsPerCustomerPage.vue?vue&type=script&lang=js"
import style0 from "./ReportSalesSumsPerCustomerPage.vue?vue&type=style&index=0&id=f702c28c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f702c28c",
  null
  
)

export default component.exports